import { Configuration, LogLevel } from '@azure/msal-browser';

const TENANT_ID = process.env.REACT_APP_AZURE_TENANT_ID || '';
const CLIENT_ID = process.env.REACT_APP_AZURE_CLIENT_ID || '';

export const msalConfig: Configuration = {
  auth: {
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (level === LogLevel.Error) console.error(message);
      },
    },
  },
};

export const loginRequest = {
  scopes: [`api://${CLIENT_ID}/access_as_user`, 'User.Read'],
};

export const tokenRequest = {
  scopes: [`api://${CLIENT_ID}/access_as_user`],
};

export const graphScopes = {
  scopes: ['User.Read'],
};
